import { Pipe, PipeTransform, ChangeDetectorRef, NgZone } from '@angular/core';

@Pipe({
  name: 'tempoPico',
  pure: false // Torna o pipe impuro para atualização constante
})
export class TempoPicoPipe implements PipeTransform {

  private lastUpdate: number = 0;

  constructor(private changeDetectorRef: ChangeDetectorRef, private ngZone: NgZone) {
    this.ngZone.runOutsideAngular(() => {
      setInterval(() => {
        this.ngZone.run(() => {
          this.lastUpdate = Date.now();
          this.changeDetectorRef.markForCheck(); // Marca para detecção de mudanças
          // this.changeDetectorRef.detectChanges(); // Marca para detecção de mudanças
        });
      }, 100);
    });
  }

  transform(items: any[]): string {
    const now = new Date();
    let maiorDiffMs = 0;

    items.forEach(item => {
      if (item.status.valor === 'Aguardando') {
        const date = new Date(item.statusAguardando.inicio);
        const diffMs = now.getTime() - date.getTime();
        if (diffMs > maiorDiffMs) {
          maiorDiffMs = diffMs;
        }
      }

      if (item.status.valor === 'Em andamento') {
        const date = new Date(item.statusEmAndamento.inicio);
        const diffMs = now.getTime() - date.getTime();
        if (diffMs > maiorDiffMs) {
          maiorDiffMs = diffMs;
        }
      }

      if (item.status.valor === 'Realizado') {
        const dateInicio = new Date(item.statusRealizado.inicio);
        const dateFim = new Date(item.statusRealizado.fim); // Usar a data de finalização
        const diffMs = dateFim.getTime() - dateInicio.getTime();
        if (diffMs > maiorDiffMs) {
          maiorDiffMs = diffMs;
        }
      }
    });

    const diffDays = Math.floor(maiorDiffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((maiorDiffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((maiorDiffMs % (1000 * 60 * 60)) / (1000 * 60));
    const diffSeconds = Math.floor((maiorDiffMs % (1000 * 60)) / 1000);

    const formattedDays = diffDays.toString().padStart(2, '0');
    const formattedHours = diffHours.toString().padStart(2, '0');
    const formattedMinutes = diffMinutes.toString().padStart(2, '0');
    const formattedSeconds = diffSeconds.toString().padStart(2, '0');

    return `${formattedDays}:${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }
}
